import { useEffect } from 'react'
import { useState } from 'react'
import { BiCommentAdd } from 'react-icons/bi'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { createConversation, chooseConversation, viewNoConversation  } from '../../../features/messenger/conversationSlice'
import styled from 'styled-components'
import { imgUrl } from 'features/constants'
import { MImageSmall } from '../zStyling.styled'
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next'


function ViewAllItem( { userId, fullName, image, isOtherMember }) {
  const { t } = useTranslation('messaging')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const { conversation, createConversationStatus } = useSelector(state => state.conversations)

  const handleClick = async () => {
    //in backend, if convo does not exist it will create a new one, and return that
    dispatch( createConversation( { 
      recipientId: userId,
      recipientType: isOtherMember ? 'User' : 'Church', 
    }))
  }

  useEffect(() => {
    if(createConversationStatus === "SUCCESS"){
      navigate(`/messages/${conversation._id}`, {replace: true})
    }

  }, [createConversationStatus, navigate, ])



  return (
    <ViewAllItemWrap  onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)} >

      <div className="vaiTop">
        <MImageSmall src={image} alt='' />
        <ItemName>{fullName}</ItemName>
      </div>

      {
         show && 
         (
             <VaiSelect onClick={handleClick} > 
              <AddIcon />  
                <span>
                  {t('newMessage')}
                </span>
             </VaiSelect> 
         )
      }
       
    </ViewAllItemWrap>
  )
}

export default ViewAllItem

const ViewAllItemWrap = styled.div`
    padding: 4px 6px;
    margin-top: 11px;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    transition: 0.4s;
    cursor: pointer;
    width: 100%;
    font-size: smaller;

    &:hover{
      box-shadow: none;
      background-color: #e4e1e1;
    }

    @media (max-width: 768px) {  
      font-size: 10px;
    }
`

const ItemName = styled.div`
    margin-left: 8px;
    font-size: 13px;
    font-weight: 500;
    color: var(--lightThemeFontColor);
    @media (max-width: 768px) {
      font-size: 10px;
    }
`

const VaiSelect = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0px 10px;
    background-color: var(--ltGreenButton);
    margin-left: 8px;
    border-radius: 8px;
    color: white;
    font-size: x-small;

    svg{
      font-size: .8rem;
      margin-right: 4px;
    }

    &:hover{
      transition: all 0.4s;
      cursor: pointer;
      background-color: green;
    }

`
